export default __webpack_public_path__ + "static/media/money.c30c733d.svg";